<template lang="pug">
  div
    el-row.margin-top
      el-col
        app-display(
          label="Nome:",
          :content="cadastroGleba.nomeCadastrante || '-'",
          :class = "'text'"
        )
        app-display(
          label="CPF:",
          :content="cadastroGleba.cpfCadastrante || '-'",
          :class = "'text'"
        )
</template>

<script>
import AppDisplay from '@/components/AppDisplay'
export default {

  components: {
    AppDisplay
  },

  props: {
    cadastroGleba: {
      required: true
    }
  },

  methods: {
    filterNull (atributo) {
      return ![null, undefined, ''].includes(atributo) ? atributo : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/components/InformacoesCadastrante.vue